import type { FETCH_TYPES, IFetchRequest, IFetchResponse } from '../interface/fetch';
import type { IProgressPromise, IProgressPromiseGenerator } from '../interface/promise';
import fetcher from './fetch';

const DEFAULT_TIMEOUT_MS = 30000; /* 30s */
const DELAY_BETWEEN_RETRIES_MS = 1000;

function fetcherWithRetry<T extends FETCH_TYPES>(
    promiser: IProgressPromiseGenerator,
    requestPayload: IFetchRequest,
    timeout = DEFAULT_TIMEOUT_MS,
    retryCount = 0,
): IProgressPromise<IFetchResponse<T>> {
    const factory = () => fetcher<T>(promiser, requestPayload, timeout);

    return promiser.retry(factory, DELAY_BETWEEN_RETRIES_MS, retryCount);
}

export default fetcherWithRetry;
